import React from "react";
import { CV } from "../components/cv";
import AndersSImg from "@/assets/images/anders-s.png";

export default function CVAndersSoderlin() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Anders Söderlin";
  }, []);

  return (
    <CV
      name="Anders Söderlin"
      title="Group CIO · Transformation & Change Leader"
      photo={AndersSImg}
      subtitle="Master data & process governance. Senior IT executive driving business-critical change across IT, ERP, data, and organizational structures — currently Group CIO."
      summary="Senior IT executive and transformation leader with extensive experience driving business-critical change across IT, ERP, data, and organizational structures. Currently Group CIO, with a strong track record of leading complex environments requiring governance, process clarity, and execution discipline. Specialized in process governance, process mapping, and master data governance, translating business needs into structured operating models, clear ownership, and sustainable improvements. Well positioned for interim and transformation assignments where rapid understanding, structure, and execution are key."
      skills={{
        Leadership: [
          "CIO / IT Executive Leadership",
          "Transformation & Change Management",
          "Executive & Stakeholder Alignment",
        ],
        "Governance & Strategy": [
          "Process governance & operating models",
          "IT Strategy & Governance",
          "Master data governance & data ownership",
          "Business case development & investment governance",
        ],
        "Process & Delivery": [
          "Process mapping & optimization",
          "Project & program management (Agile, PRINCE2, PROPS)",
          "Logical Thinking Process framework",
        ],
        Security: ["Cyber security analysis & contingency planning"],
        Languages: ["Swedish (native)", "English (very good, spoken and written)"],
      }}
      experience={[
        {
          role: "Group Chief Information Officer (Group CIO)",
          company: "Scandinavian Cosmetics Group",
          period: "2024 – Present",
          description:
            "Group-wide responsibility for IT, digital platforms, cyber security, enterprise architecture, and infrastructure. Drives governance and structuring ways of working across IT and business processes.",
          highlights: [
            "Focus on strategy, process governance, process mapping, master data governance, and IT.",
          ],
        },
        {
          role: "Chief Information Officer / IT Manager, Sweden",
          company: "Orkla Foods Sverige AB",
          period: "2020 – 2024",
          description:
            "CIO and IT operational manager for Orkla Foods Sverige AB and subsidiaries. IT strategic and operational responsibility for IT landscape, governance and infrastructure.",
          highlights: [
            "Responsible for digitalization strategy and chair of digitalization and IT governance board.",
            "Cyber security analysis and business unit IT contingency owner.",
          ],
        },
        {
          role: "IT Manager and Business Partner, Sweden",
          company: "COWI AB",
          period: "2018 – 2020",
          description:
            "IT Manager and Business Partner for Sweden. Strategic and operational interface between COWI AB and Global IT.",
          highlights: [
            "Assisted Global IT with project management and IT adoption on global initiatives.",
            "Negotiation and procurement of IT solutions.",
            "Responsible for IT in acquisitions and relocation projects.",
          ],
        },
        {
          role: "IT Business Partner",
          company: "Axis Communications AB, IT Services",
          period: "2016 – 2018",
          description:
            "Established a new department (E-Business Partner Office) within IT Services. Strategic interface with assigned business units/functions globally at executive level.",
          highlights: [
            "Developed technology strategies; performed business and root cause analysis.",
            "Responsible for recommendations on IT solutions and business process improvements.",
          ],
        },
        {
          role: "Project Manager",
          company: "Axis Communications AB, E-Business",
          period: "2013 – 2016",
          description:
            "Project manager for national and international projects within Sales, Marketing and Customer Support.",
          highlights: [
            "Requirements specification; implementing and coaching Agile methods and ways of working.",
          ],
        },
        {
          role: "Project Manager / Product Owner / Team Lead",
          company: "CDON AB, Group IT",
          period: "2010 – 2013",
          description:
            "Team lead for system / web development team including distributed teams. Project Manager / Scrum Master for webshop solution projects and coordination.",
          highlights: [
            "Process owner for development / requirements process.",
            "Designed and implemented project management process and Agile delivery method.",
          ],
        },
        {
          role: "Regional Service Manager",
          company: "Relacom AB, LAN / IT",
          period: "2007 – 2010",
          description:
            "Regional manager for Region South enterprise communication solutions. Part of business area management team; coaching and mentoring.",
          highlights: [
            "Responsible for budget, regional sales, and a national business contract.",
            "Planning and design of wireless and wired networks; working environment responsibility.",
          ],
        },
        {
          role: "Business Developer / Business Improvement",
          company: "Relacom AB, LAN / IT",
          period: "2006 – 2007",
          description:
            "Responsible for training and skills development and information dissemination. KPI analysis and monitoring; support to regional management.",
          highlights: [
            "Developed an accepted universal implementation model for Relacom.",
            "Prepared quotations and participated in public procurement.",
          ],
        },
      ]}
      education={[
        {
          degree: "BRMP – Business Relationship Management Professional",
          institution: "APMG International",
          year: "Certification",
        },
        {
          degree: "ITIL Foundation – IT Service Management",
          institution: "Axelos",
          year: "Certification",
        },
        {
          degree: "B.Sc. Computer Software Engineering",
          institution: "Malmö University",
          year: "Degree",
        },
        {
          degree: "GDPR / Data protection training",
          institution: "Informator / Edmar Law",
          year: "Training",
        },
        {
          degree: "Situational Leadership II",
          institution: "Svenska Konsulthuset",
          year: "Training",
        },
      ]}
    />
  );
}
